const $ = jQuery

class ItemRepository {
    downloadedItems: {
        [key:string] : string
    } = {}

    downloadQueue: {
        [key:string] : [
            number
        ]
    } = {}

    ajaxUrl: string

    private constructor(ajaxUrl: string) {
        this.ajaxUrl = ajaxUrl
    }

    /**
     * Returns the rendered post as HTML string if it has already been downloaded,
     * returns null and enqueues the post if it hasn't been downloaded yet.
     * Enqueues posts can be downloaded using {@link ItemRepository.fetch}
     * @param postId The id of the post
     * @param templateId The id of the template to be used
     * @param blogId The id of the blog, in multisite context, can be null to use current site
     */
    getItem(postId: number, templateId: number, blogId: number = null): JQuery {
        const post = this.downloadedItems[`${blogId}$${templateId}#${postId}`]
        if (post == null) {
            if (this.downloadQueue[`${blogId}$${templateId}`] == null) {
                this.downloadQueue[`${blogId}$${templateId}`] = [ postId ]
            } else {
                this.downloadQueue[`${blogId}$${templateId}`].push(postId)
            }
            return null
        }
        const itemView = $(`<div class="grid-item" id="grid-item-${postId}"/>`)
        const itemContentWrapper = $('<div class="grid-item-content-wrapper" />')
        itemContentWrapper.html(post)
        itemView.append(itemContentWrapper)
        return itemView
    }

    async fetch(templateId: number, blogId: number = null): Promise<void> {
        const postIds = this.downloadQueue[`${blogId}$${templateId}`]
        if (!postIds || !postIds.length) return
        let url = `${this.ajaxUrl}?template=${templateId}&posts[]=${postIds.join('&posts[]=')}`
        if (blogId !== null) url += `&blog=${blogId}`
        const response = await fetch(url, {
            headers: {
                'Accept-Encoding': 'gzip, deflate'
            }
        })
        const items = await response.json()
        for(const item in items) {
            this.downloadedItems[`${blogId}$${templateId}#${item}`] = items[item]
        }
        this.downloadQueue[`${blogId}$${templateId}`] = null
    }

    private static instance : ItemRepository
    static getInstance(ajaxUrl: string) : ItemRepository {
        if (ItemRepository.instance == null) {
            ItemRepository.instance = new ItemRepository(ajaxUrl)
        }
        return ItemRepository.instance
    }
}

export default ItemRepository